import { Component, input, model } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mbm-search',
  imports: [TranslateModule],
  templateUrl: './mbm-search.component.html',
  styleUrl: './mbm-search.component.scss',
})
export class MbmSearchComponent {
  readonly placeholderKey = input<string>('components.search.placeholder');
  readonly value = model<string>('');

  protected onInput(event: Event): void {
    this.value.set((event.target as HTMLInputElement).value);
  }

  protected clearSearch(): void {
    this.value.set('');
  }
}
